// API基础配置
export const API_BASE_URL = 'https://koh30.shangyundian.cn/api'
export const UPLOAD_BASE_URL = 'https://koh30.shangyundian.cn/upload'

// Token存储key
export const TOKEN_KEY = 'auth_token'

// 拼接图片URL
export function getImageUrl(imgPath) {
  if (!imgPath) return ''
  // 如果已经是完整URL，直接返回
  if (imgPath.startsWith('http://') || imgPath.startsWith('https://')) {
    return imgPath
  }
  // 拼接上传域名
  return `${UPLOAD_BASE_URL}/${imgPath}`
}

